import { Skeleton, Text } from '@radix-ui/themes'

const SecureDnsSkeleton = () => {
  return (
    <div className="w-full flex flex-col  p-4">
      <div className="flex w-full space-x-4 h-12 mb-2 justify-between">
        <div className="flex w-1/3 space-x-4">
          <Skeleton className="h-12 w-1/2 w-full flex-grow" />
        </div>
        <div className="flex w-1/4 space-x-4">
          <Skeleton className="h-12 w-full ml-auto" />
        </div>
      </div>
      <div className="flex space-x-4">
        <Text>
          <Skeleton>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque felis tellus, efficitur id convallis
            a, viverra eget libero.
          </Skeleton>
        </Text>
      </div>
      <div className="flex space-x-4">
        <Text>
          <Skeleton>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</Skeleton>
        </Text>
      </div>
      <div className="flex pt-8 space-x-4">
        <Skeleton className="h-40 w-1/2 w-full flex-grow" />
      </div>
      <div className="flex pt-8 space-x-4">
        <Skeleton className="h-12 w-1/2 w-full flex-grow" />
      </div>
      <div className="flex pt-8 space-x-4">
        <Skeleton className="h-60 w-1/2 w-full flex-grow" />
      </div>
    </div>
  )
}

export default SecureDnsSkeleton
